import React from 'react';

const APPS = [
  { code: 'LNAT', name: 'Law National Aptitude Test' },
  { code: 'TMUA', name: 'Test of Mathematics for University Admission' },
  { code: 'TARA', name: 'Test of Academic Reasoning for Admissions' },
  { code: 'UCAT', name: 'University Clinical Aptitude Test' },
  { code: 'ESAT', name: 'Engineering & Science Admissions Test' },
  { code: 'OXBRIDGE', name: 'Oxbridge Application Prep' },
  { code: 'DEGREE APP.', name: 'Degree Apprenticeships' },
  { code: 'MEDICINE', name: 'Medicine Admissions Prep' },
];

export default function EduAppsGrid() {
  return (
    <div className="edu-landing-apps-grid">
      {APPS.map((app) => (
        <div className="edu-landing-app-card" key={app.code}>
          <div className="edu-landing-app-code">{app.code}</div>
          <div className="edu-landing-app-name">{app.name}</div>
        </div>
      ))}
    </div>
  );
}
